import { isEmpty, pick } from "lodash";
import React, { useState, useContext, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import styles from "../assets/newCss/sky.css";
import { Helmet } from "react-helmet";
import { toast } from "wc-toast";

function ChangePassword(props) {
  let { isLoged, user } = useContext(AuthProvider);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {},
  });
  const [password_same, set_password_same] = useState();
  const [data, setData] = useState({});
  useEffect(() => {
    if (!isEmpty(user)) {
      if (!user?.results?.isPasswordReset) {
        navigate("/change-password");
      }
    } else {
      navigate("/");
    }
  }, [user]);
  const onSubmit = async (body) => {
    set_password_same(true);

    if (body.newPassword !== body.confirmPassword) {
      set_password_same(false);
    } else {
      body.uniqueId = Math.random() * 10000;
      const obj = pick(body, ["oldPassword", "newPassword", "uniqueId"]);
      const { status, data } = await apiPost(apiPath.changePassword, obj);
      if (status === 200) {
        if (data.success) {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh_token");
        //   localStorage.setItem("token", data.results.token);
        //   localStorage.setItem("refresh_token", data.results.refresh_token);
          navigate("/login");
        } else {
          toast.error(data.message);
        }
      } else {
        toast.error(data.message);
      }
    }
  };

  return (
    <div className="newLogin">
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no"
        />
      </Helmet>

      <div className="login_main" style={{ height: `100vh` }}>
        <header className="login-head">
          {/* <Link to="/" className="close"></Link> */}
          {/* <h1></h1> */}
          {/* <div id="powerWrap" className="betfair-wrap">
            <p>Powered by</p>
            <span>
              <img
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  "/assets/images/betfair_black.png"
                }
                alt=""
                draggable="false"
              />
            </span>
          </div> */}
        </header>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <dl className="form-login">
            <Form.Group className="  mb-2">
              <Form.Control
                type="password"
                placeholder="Enter New Password"
                className={errors.newPassword ? " is-invalid " : ""}
                {...register("newPassword",  {
                        required: "Please enter password",
                        minLength: {
                          value: 4,
                          message:
                            "Password should contain atleast 8 characters",
                        },
                        maxLength: {
                          value: 15,
                          message:
                            "Password should contain maximum 16 characters",
                        },
                      
                      
                  
                  // validate: (value) => {
                  //   if (value === "") {
                  //     return true;
                  //   }
                  //   var paswd =
                  //     "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})";
                  //   if (value.match(paswd)) {
                  //     return true;
                  //   } else {
                  //     return "New Password must have minimum 8 character with 1 lowercase, 1 uppercase, 1 numeric and 1 special character.";
                  //   }
                  // },
                })}
              />
              {errors.newPassword && errors.newPassword.message && (
                <label className="invalid-feedback text-left">
                  {errors.newPassword.message}
                </label>
              )}
            </Form.Group>
            <Form.Group className="  mb-2">
              <Form.Control
                type="password"
                placeholder="Confirm Password"
                className={
                  errors.confirmPassword || password_same === false
                    ? " is-invalid "
                    : ""
                }
                {...register("confirmPassword", {
                  required: "Please enter confirm password",
                  validate: (value) => {
                    if (value === "") {
                      return true;
                    }
                  },
                })}
              />
              {errors.confirmPassword && errors.confirmPassword.message && (
                <label className="invalid-feedback text-left">
                  {errors.confirmPassword.message}
                </label>
              )}
              {password_same === false && errors.confirmPassword !== "" && (
                <label className="invalid-feedback text-left">
                  Password does not match.
                </label>
              )}
            </Form.Group>
            <Form.Group className="  mb-2">
              <Form.Control
                type="password"
                placeholder="Enter Old Password"
                className={errors.oldPassword ? " is-invalid " : ""}
                {...register("oldPassword", {
                  required: "Please enter old password",
                  // validate: (value) => {
                  //   if (value === "") {
                  //     return true;
                  //   }
                  //   var paswd =
                  //     "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})";
                  //   if (value.match(paswd)) {
                  //     return true;
                  //   } else {
                  //     return "Old password must have minimum 8 character with 1 lowercase, 1 uppercase, 1 numeric and 1 special character.";
                  //   }
                  // },
                })}
              />
              {errors.oldPassword && errors.oldPassword.message && (
                <label className="invalid-feedback text-left">
                  {errors.oldPassword.message}
                </label>
              )}
            </Form.Group>
            <dd>
              <Button type="submit" className="btn-send w-100" id="loginBtn">
                Update
              </Button>
            </dd>
            {isLoged == "failed" && (
              <dd id="errorMsg" class="state">
                Login name or password is invalid! Please try again.
              </dd>
            )}
          </dl>
        </Form>
      </div>
    </div>
  );
}

export default ChangePassword;
